import React from "react";
import DetailsSection from "./DetailsSection";
import DetailsSlideOver from "./DetailsSlideOver";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import {UpdateJobApplicationControlProps} from "../JobApplicationEditor";
import {FormattedMessage} from "react-intl";
import {SetStateFn} from "@/utils/SetStateUtils";

type Props = UpdateJobApplicationControlProps & {
    isLargeScreen: boolean,
    showDetailsSection: boolean,
    setShowDetailsSection: SetStateFn<boolean>,
    jobApplication: JobApplicationDetails | undefined,
};

const JobApplicationFormDetails = ({
                                       isLargeScreen,
                                       setShowDetailsSection,
                                       showDetailsSection,
                                       jobApplication,
                                       ...updateFormProps
                                   }: Props) => {
    const detailsSection = (
        <DetailsSection
            jobApplication={jobApplication}
            {...updateFormProps}
        />
    );

    if (isLargeScreen) {
        return (
            <div className={"shrink-0 grow-0 w-[500px]"}>
                {detailsSection}
            </div>
        );
    }

    return (
        <DetailsSlideOver
            showDetailsSection={showDetailsSection}
            setShowDetailsSection={setShowDetailsSection}
            title={<FormattedMessage id={"detailsAlt"}/>}
        >
            {detailsSection}
        </DetailsSlideOver>
    );
};

export default JobApplicationFormDetails;